import dayjs from 'dayjs';
import { PROGRAMS } from '@/shared/config';
import type { ProgramSubscriptionMessageProps } from './programSubscriptionMessage.types';

const ProgramSubscriptionMessage = ({
  programName,
  isProgramSubscribed,
  toggleSubscriptionDate,
  serviceCenterEmail,
}: ProgramSubscriptionMessageProps) => {
  const actionDate = dayjs(toggleSubscriptionDate).format('MM/DD/YYYY');

  if (programName === PROGRAMS.PROTECT_PLUS) {
    return (
      <>
        Your clinic has just {isProgramSubscribed ? 'subscribed to' : 'unsubscribed from'} the
        Protect+ program on {actionDate}. Contact the Service Center via the following email{' '}
        <a className="blue-text" href={`mailto:${serviceCenterEmail}`}>
          {serviceCenterEmail}
        </a>{' '}
        if you have any questions.
      </>
    );
  }

  return (
    <>
      Your clinic has just {isProgramSubscribed ? 'subscribed to' : 'unsubscribed from'} the Renewal
      Stock on {actionDate}.
      {!isProgramSubscribed && ' Please return your renewal devices (if any).'} Contact the Service
      Center via the following email{' '}
      <a className="blue-text" href={`mailto:${serviceCenterEmail}`}>
        {serviceCenterEmail}
      </a>{' '}
      if you have any questions.
    </>
  );
};

export default ProgramSubscriptionMessage;
